





























































































import { Component, Vue, Prop } from "vue-property-decorator";
import EventBus from "../event-bus";

@Component
export default class EmergencyPopup extends Vue {
  show_modal: boolean = false;
  saving: boolean = false;
  name: string = "";
  description: string = "";
  status: string = "";
  priority: string = "";
  coordinates: Array<number> = [0, 0];
  extent: Array<number> = [];
  zoom: number = 10;
  center: Array<number> = [16, 38];
  rotation: number = 0;
  message: any = 0;
  errorMessage: string = "";
  bingmaps = {
    name: "bingmaps",
    title: "Stradario",
    apiKey: "AlqY4L0HnlkZXdwBIX5UY-efOpgQRbIIaUC-tbQERW9K-VsF2VobKqkujWSzpy8G",
    imagerySet: "RoadOnDemand",
    visible: true
  };

  changeCoordinates(event:any) {
    if( !this.message )
      this.coordinates = event.coordinate;
  }

  onMapMounted() {
    (this.$refs.map as any).$view.setMaxZoom(19);
    (this.$refs.map as any).$view.setMinZoom(4);
    var self = this;
    this.$http.get("/emma/admin/city_bbox").then(resp => {
      if(self.message && self.message.coordinates)
        self.$data.center = self.coordinates;
      else {
        self.$data.center = resp.data.center;
        self.$data.bbox = resp.data.bbox;
      }
      (self.$refs.map as any).refresh();
    });
  }

  async createEmergency() {
    const formRes = this.$el.querySelector("form");
    const form = formRes ? <HTMLFormElement>formRes[0] : null;

    if (form && !form.reportValidity()) return;
    let data = new FormData();
    data.append("name", this.name);
    data.append("description", this.description);
    data.append("priority", this.priority);
    const coords = JSON.stringify(this.coordinates);
    data.append("coordinates", coords);
    if (this.message) data.append("message_id", this.message.id.toString());
    try {
      this.saving = true;
      const resp = await this.$http({
        method: "POST",
        url: "/emma/admin/emergencies",
        data: data
      });
      EventBus.$emit("new-emergency", resp.data);
      EventBus.$emit("remove-warning", this.message);
    } catch (e) {
      this.errorMessage = "Si è verificato un errore: " + e;
    } finally {
      this.saving = false;
    }

    this.close();
  }

  show() {
    this.show_modal = true;
  }

  close() {
    this.show_modal = false;
    this.errorMessage = "";
    this.saving = false;
    this.description = "";
    this.name = "";
    this.status = "";
    this.priority = "";
    this.message = null;
  }
}
